/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationRecapCustomerInfoMutation from '../graphql/mutations/SaveSimulationRecapCustomerInfoMutation.js';

export const useSaveSimulationRecapCustomerInfoMutation = () => {
  return useCommitMutation(SaveSimulationRecapCustomerInfoMutation, {
    dataProp: 'saveSimulationRecapCustomerInfo_M_simulation_recap'
  });
};

export default useSaveSimulationRecapCustomerInfoMutation;
